import { MessageCircle, FileText } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { scrollToId } from "../lib/site";
import { Reveal } from "./Reveal";

export function BigCta() {
  const { wa } = useSite();
  return (
    <section data-testid="cta-banner" className="relative py-24 sm:py-32 bg-navy-800 overflow-hidden noise-overlay">
      <div className="absolute inset-0 blueprint-grid opacity-70" />
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-ice/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-glacier/10 blur-3xl" />
      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold uppercase leading-[0.95] tracking-tight text-frost" data-testid="cta-headline">
            Butuh <span className="text-ice">Cold Storage</span> untuk Bisnis Anda?
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-steel text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            Konsultasikan kebutuhan Anda dengan tim kami dan dapatkan solusi yang sesuai dengan kebutuhan serta budget Anda.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-9 flex flex-wrap justify-center gap-4">
            <a
              data-testid="cta-consult-btn"
              href={wa()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 bg-ice text-navy-950 font-semibold px-8 py-4 rounded-sm hover:bg-glacier transition-colors glow-ice"
            >
              <MessageCircle className="w-5 h-5" />
              Konsultasi Gratis
            </a>
            <button
              data-testid="cta-quote-btn"
              onClick={() => scrollToId("penawaran")}
              className="inline-flex items-center gap-2.5 border border-frost/25 text-frost font-semibold px-8 py-4 rounded-sm hover:border-ice hover:text-ice transition-colors"
            >
              <FileText className="w-5 h-5" />
              Minta Penawaran Harga
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
